module.exports = __webpack_public_path__ + "static/img/check7.4a7a0c68.jpg";